import handleChange from '../../utils/handleChange';
import handleNestedChange from '../../utils/handleNestedChange';
import './dropdownReg.css';

export default function DropdownReg({ label, name, options, value, req, setFormData, nest, error, disabled }) {
    function handleGroupChange() {
        if (name === 'group' || name === 'vehicle') {
            setFormData((prevState) => {
                const updatedPrice = prevState.price.map((item) => ({
                    ...item,
                    meetupPoint: [],
                    vehicle: [], // clear vehicles
                    installment: [] // clear installments
                }));

                return {
                    ...prevState,
                    price: updatedPrice
                };
            });
        }
    }

    return (
        <div className='dropRegDiv'>
            <label className='dropRegLabel'>{label}</label>
            <div className='dropRegInputDiv'>
                <select
                    value={value}
                    name={name}
                    onChange={
                        nest
                            ? (e) => handleNestedChange(e, setFormData, nest)
                            : (e) => {
                                  handleChange(e, setFormData);
                                  handleGroupChange();
                              }
                    }
                    required={req}
                    disabled={disabled}
                    className={`dropRegSelect ${error ? 'error-highlight' : ''}`}
                >
                    <option value='-1'>Select</option>
                    {Array.isArray(options) &&
                        options.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                </select>
            </div>
        </div>
    );
}

export function DropdownRegCamp({ label, name, options, value, req, setFormData, nest, error, disabled }) {
    return (
        <div className='dropRegDiv'>
            <label className='dropRegLabel'>{label}</label>
            <div className='dropRegInputDiv'>
                <select
                    value={value}
                    name={name}
                    onChange={
                        nest
                            ? (e) => handleNestedChange(e, setFormData, nest)
                            : (e) => {
                                  handleChange(e, setFormData);
                              }
                    }
                    required={req}
                    disabled={disabled}
                    className={`dropRegSelect ${error ? 'error-highlight' : ''}`}
                >
                    <option value='-1'>Select</option>
                    {Array.isArray(options) &&
                        options.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                </select>
            </div>
        </div>
    );
}
